import React from "react";
import "./styles.css";

export const Loader = ({}) => {
  return (
    <div className="container h-100 d-flex justify-content-center p-5">
      <div className="Box my-auto">
        <span>
          <span></span>
        </span>
      </div>
    </div>
  );
};
